import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import UserImg from '../assets/images/Frame 440.png';
import useUserStore from "../store/userStore";
import { UserIcon } from "lucide-react";
import {
  Heart,
  LogOut,
  ChevronLeft,
} from "lucide-react";
import { toast } from "react-toastify";

interface ProfileSection {
  id: string;
  title: string;
  icon: React.ReactNode;
  description: string;
  count?: number;
  link?: string;
}

const UserProfile: React.FC = () => {
  const { user, clearUser } = useUserStore();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<string>("overview");
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const handleLogout = () => {
    clearUser();
    toast.success("با موفقیت خارج شدید", {
      className: "toast",
      hideProgressBar: true
    });
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="max-w-md mx-auto px-4 py-8">
        <div className="bg-white rounded-2xl shadow-md p-8">
          {/* User Info */}
          <div className="flex flex-col items-center">
            {/* <img
          src={UserImg}
          alt="User"
          className="w-24 h-24 rounded-full object-cover"
        /> */}
            <UserIcon size={64} className="text-gray-700 border-2 border-gray-700 rounded-full" />
            <h1 className="mt-4 text-lg font-myYekanBold text-gray-800">
              {user?.fullName || user?.username || "کاربر لوتکا"}
            </h1>
          </div>

          {/* Actions */}
          <div className="mt-8 space-y-3 text-gray-600">
            <Link
              to="/favorites"
              className="flex items-center justify-between p-4 rounded-xl border border-gray-100 hover:bg-gray-50 transition"
            >
              <div className="flex items-center gap-3">
                <Heart size={20} className="text-gray-600" />
                <span className="font-myYekanMedium">
                  علاقه‌مندی‌ها
                </span>
              </div>

              <ChevronLeft size={16} />
            </Link>

            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-between p-4 rounded-xl border border-gray-100 hover:bg-red-50 transition"
            >
              <div className="flex items-center gap-3">
                <LogOut size={20} />
                <span className="font-myYekanMedium text-gray-600">
                  خروج از حساب
                </span>
              </div>

              <ChevronLeft size={16}/>
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default UserProfile;